module.exports = __webpack_public_path__ + "assets/img/thumb-Earlytrade-Website.8b8dd654.webp";